'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typography = require('../../schema/component/typography.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Defines elements for solving dynamic performance issues
var ItemH1 = 'h1';
var ItemH2 = 'h2';
var ItemH3 = 'h3';
var ItemH4 = 'h4';
var ItemH5 = 'h5';
var ItemH6 = 'h6';
var ItemA = 'a';
var ItemP = 'p';
var ItemSpan = 'span';
var ItemDiv = 'div';

var Typography = exports.Typography = function Typography(props) {
  var component = props.component,
      children = props.children,
      variant = props.variant;

  var headline = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  var subtitle = ['subtitle1-medium', 'subtitle1-reguler', 'subtitle2-medium', 'subtitle2-reguler'];
  var textbody = ['textbody1-medium', 'textbody1-reguler', 'textbody2-medium', 'textbody2-reguler', 'textbody3-medium', 'textbody3-reguler'];
  var textbutton = ['textbutton'];
  var caption = ['caption', 'caption-small'];
  var overline = ['overline'];
  var link = ['link'];
  var texterror = ['texterror'];
  var list = [].concat(headline, subtitle, textbody, textbutton, caption, overline, link, texterror);

  var onCheckType = function onCheckType(key) {
    if (headline.includes(key)) {
      return 'headline';
    }if (subtitle.includes(key)) {
      return 'subtitle';
    }if (textbody.includes(key)) {
      return 'textbody';
    }if (textbutton.includes(key)) {
      return 'textbutton';
    }if (caption.includes(key)) {
      return 'caption';
    }if (overline.includes(key)) {
      return 'overline';
    }if (link.includes(key)) {
      return 'link';
    }if (texterror.includes(key)) {
      return 'texterror';
    }

    return 'subtitle';
  };

  var onCheckVariant = function onCheckVariant(payload) {
    if (list.includes(payload)) {
      return payload;
    }
    return 'subtitle1-medium';
  };

  var data = _extends({}, _typography.properties[onCheckType(variant)].properties.props.properties, _typography.properties[onCheckType(variant)].properties.children.properties[onCheckVariant(variant)].properties);
  var dom = component || _typography.properties[onCheckType(variant)].properties.children.properties[onCheckVariant(variant)].properties.component;

  var fullProps = _extends({
    'data-color': data.color,
    'data-display': data.display,
    'data-font-family': data.fontFamily,
    'data-font-size': data.fontSize,
    'data-font-weight': data.fontWeight,
    'data-letter-spacing': data.letterSpacing,
    'data-line-height': data.lineHeight,
    'data-text-align': data.textAlign,
    'data-text-transform': data.textTransform,
    'data-width': data.width
  }, props);

  switch (dom) {
    case 'h1':
      return _react2.default.createElement(
        ItemH1,
        fullProps,
        children
      );
    case 'h2':
      return _react2.default.createElement(
        ItemH2,
        fullProps,
        children
      );
    case 'h3':
      return _react2.default.createElement(
        ItemH3,
        fullProps,
        children
      );
    case 'h4':
      return _react2.default.createElement(
        ItemH4,
        fullProps,
        children
      );
    case 'h5':
      return _react2.default.createElement(
        ItemH5,
        fullProps,
        children
      );
    case 'h6':
      return _react2.default.createElement(
        ItemH6,
        fullProps,
        children
      );
    case 'p':
      return _react2.default.createElement(
        ItemP,
        fullProps,
        children
      );
    case 'a':
      return _react2.default.createElement(
        ItemA,
        fullProps,
        children
      );
    case 'span':
      return _react2.default.createElement(
        ItemSpan,
        fullProps,
        children
      );
    default:
      return _react2.default.createElement(
        ItemDiv,
        fullProps,
        children
      );
  }
};

Typography.defaultProps = {
  children: null,
  component: null,
  variant: 'h1'
};

Typography.propTypes = {
  component: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  variant: _propTypes2.default.string
};

exports.default = Typography;